import React from "react";
import { RehireReportContainer } from "../../../containers";

const RehireReport = (props) => {
  return <RehireReportContainer {...props} />;
};

export default RehireReport;
